import request from '@/utils/request.js'

const purchaseApi = process.env.VUE_APP_PURCHASE_API
const performanceApi = process.env.VUE_APP_PERFORMANCE_API

// 分页查询供应商待办任务列表（非待办事项列表）
export function getSupplierWaitRaskPageApi(params) {
  return request(
    {
      url: purchaseApi + `/workbench/supplier/wait-task/page`,
      method: 'get',
      params
    },
    false
  )
}

// 分页查询供应商待办任务列表（非待办事项列表）
export function getPurchaserWaitRaskPageApi(params) {
  return request(
    {
      url: purchaseApi + `/workbench/purchaser/wait-task/page`,
      method: 'get',
      params
    },
    false
  )
}

// 分页查询履约验收待办列表
export function getPerformanceWaitTaskPageApi(params) {
  return request(
    {
      url: performanceApi + `/performance/wait-task/page`,
      method: 'get',
      params
    },
    false
  )
}
